// extracted by mini-css-extract-plugin
export default {"modal":"jsmodal_modal__ow0cM"};